module.exports = __webpack_public_path__ + "assets/home-table3.fcd7ef21.svg";